import React from 'react';
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
} from '@mui/material';
import { makeStyles } from '@mui/styles';
import {
  salesHeaderTyps1,
  salesHeaderTyps2,
} from '../../utils/forecastStaticData';
import SalesStaticsHeadquarterRow from './SalesStaticsHeadquarterRow';

const useStyles = makeStyles({
  table: {
    '& .MuiTableCell-root': {
      border: '1px solid rgba(224, 224, 224, 1)',
      align: 'center',
    },
  },
});

const SalesStaticsHeadquarterTable = ({ data, headerRows, tableRef }) => {
  const classes = useStyles();

  if (!headerRows || !data) {
    return null;
  }

  const headerCell1 = salesHeaderTyps1.map((typ, index) => (
    <TableCell align="center" key={index}>
      {typ.name}
    </TableCell>
  ));

  const headerCell2 = salesHeaderTyps2.map((typ, index) => (
    <TableCell align="center" key={index}>
      {typ.name}
    </TableCell>
  ));

  return (
    <Paper sx={{ overflow: 'auto', my: 1 }}>
      <TableContainer
        sx={{ width: '100%', display: 'table', tableLayout: 'fixed' }}
      >
        <Table size="small" className={classes.table} ref={tableRef}>
          <TableHead>
            <TableRow>
              <TableCell align="center" rowSpan={2}>
                본부
              </TableCell>

              {headerRows.map((header) => (
                <TableCell
                  colSpan={header?.val === 'sp' ? 4 : 2}
                  align="center"
                  key={header.val}
                >
                  {header.name}
                </TableCell>
              ))}
            </TableRow>
            <TableRow>
              {headerRows.map((header) => {
                return header.val === 'sp' ? headerCell2 : headerCell1;
              })}
            </TableRow>
          </TableHead>
          <TableBody>
            {Array.isArray(data) && data.length === 0 ? (
              <TableRow>
                <TableCell colSpan={9} align="center">
                  데이터가 없습니다.
                </TableCell>
              </TableRow>
            ) : (
              <SalesStaticsHeadquarterRow headerRows={headerRows} data={data} />
            )}
          </TableBody>
        </Table>
      </TableContainer>
    </Paper>
  );
};

export default SalesStaticsHeadquarterTable;
